// MenuTable.js
import React, { useState, useEffect, useRef } from "react";
import "./MenuTable.css";
import EditModal from "../editDetails/edit";
import api from "../../../../services/api";
import { useToast } from "../../../../mesageToast/ToastContainer";
import warning from "../../../../Assets/warning.svg";
import { useDispatch } from "react-redux";
import {
  addNewCategoriesOtherThanList,
  editMenuDetails,
  markAvailable,
  removeItem,
} from "../../../../redux/Slice/OrderSlice";

const MenuTable = ({ items, refresh, category, categoryList }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [popupVisible, setPopupVisible] = useState(null); // Track the visible popup for each item
  const [showDeletePopup, setShowDeletePopup] = useState(false); // New state for delete confirmation popup
  const [itemToDelete, setItemToDelete] = useState(null); // Track the item to be deleted
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const popupRef = useRef(null); // Initialize popupRef with useRef
  const [firstSelection, setFirstSelection] = useState(null);

  const addToast = useToast();
  const dispatch = useDispatch();
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedItems(items.map((item) => item._id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (item) => {
    if (selectedItems.length === 0) {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.includes(item._id)
          ? prevSelectedItems.filter((itemId) => itemId !== item._id)
          : [...prevSelectedItems, item._id]
      );
      setFirstSelection(item.available);
      return;
    }
    if (selectedItems.length > 0 && firstSelection === item.available) {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.includes(item._id)
          ? prevSelectedItems.filter((itemId) => itemId !== item._id)
          : [...prevSelectedItems, item._id]
      );
    } else {
      addToast(
        "Error",
        "You can't select items with different availability.",
        "error"
      );
    }
  };

  const handleMarkUnavaliable = (id) => {
    api
      .patch(`/restaurant-management/menu/toggleAvailability/${id}`)
      .then((response) => {
        addToast("Item Updated", "Item has been updated.", "success");
        refresh();
        dispatch(markAvailable([id]));
        if (selectedItems.length === 1) {
          setFirstSelection(null);
        }
        setSelectedItems((prevSelectedItems) =>
          prevSelectedItems.filter((itemId) => itemId !== id)
        );
      })
      .catch((error) => {
        addToast("Error", "Failed to update item.", "error");
        console.log(error);
      });
  };
  useEffect(() => {
    setSelectedItems([]);
    setFirstSelection(null);
  }, [category]);
  const handleDeleteItem = () => {
    if (itemToDelete) {
      api
        .delete(`/restaurant-management/menu/deleteDish/${itemToDelete}`)
        .then((response) => {
          addToast("Item Deleted", "Item has been deleted.", "success");
          refresh(); // Refresh the list after deletion
          setShowDeletePopup(false); // Hide the delete popup
          setItemToDelete(null); // Reset itemToDelete
          dispatch(removeItem(itemToDelete));
        })
        .catch((error) => {
          addToast("Error", "Failed to delete item.", "error");
          console.log(error);
        });
    }
  };

  const handleToggleAvailability = () => {
    api
      .patch("/restaurant-management/updateToggleAvalability", { selectedItems })
      .then((response) => {
        setSelectedItems([]);
        addToast(
          "Items Updated",
          "Selected items have been updated.",
          "success"
        );
        dispatch(markAvailable(selectedItems));
        setFirstSelection(null);
        refresh();
      })
      .catch((error) => {
        addToast("Error", "Failed to update items.", "error");
        console.log(error);
      });
  };
  const togglePopup = (index, event) => {
    event.stopPropagation();
    setPopupVisible(popupVisible === index ? null : index);
  };
  const handleOnCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedItem(null);
  };
  const handleClickOutside = (event) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      !event.target.classList.contains("more-options")
    ) {
      setPopupVisible(null);
    }
  };

  useEffect(() => {
    if (popupVisible !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupVisible]);

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setIsEditModalOpen(true);
    setPopupVisible(null);
  };

  const handleSave = (updatedDetails) => {
    api
      .post("/restaurant-management/menu/updateDetails", updatedDetails)
      .then((response) => {
        addToast("Item Updated", "Item details have been updated.", "success");
        refresh();
        setIsEditModalOpen(false);
        setSelectedItem(null);
        dispatch(editMenuDetails(updatedDetails));
        if (updatedDetails.category === "Others") {
          dispatch(
            addNewCategoriesOtherThanList(updatedDetails.addNewCategory)
          );
        }
      })
      .catch((error) => {
        addToast("Error", "Failed to update item details.", "error");
        console.log(error);
      });

    // console.log(updatedDetails);
  };

  return (
    <>
      <table className="menu-table">
        <thead>
          <tr>
            <th>
              {/* {category === "All" ? null : (
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    selectedItems.length === items.length && items.length > 0
                  }
                />
              )} */}
            </th>
            <th>
              <p style={{ minWidth: "100px", textAlign: "left" }}>Name</p>
            </th>
            <th>
              <p style={{ minWidth: "100px", textAlign: "left" }}>Price</p>
            </th>
            <th>
              <p style={{ minWidth: "100px", textAlign: "left" }}>Category</p>
            </th>
            <th>
              <p style={{ minWidth: "100px", textAlign: "left" }}>
                Actions
                {selectedItems.length > 0 && (
                  <button
                    className="mark-unavailable mark-all"
                    onClick={handleToggleAvailability}>
                    {firstSelection ? "Mark Unavailable" : "Mark Available"}
                  </button>
                )}
              </p>
            </th>
          </tr>
        </thead>
        {items.length === 0 ? (
          <tbody>
            <tr>
              <td colSpan="5" style={{ whiteSpace: "nowrap" }}>
                No items found
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {items.map((item, index) => {
              const isLastRow = index === items.length - 1;
              return (
                <tr
                  key={item._id}
                  className={
                    item.available ? "avalaibleDish" : `unavalaibleDish`
                  }>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item._id)}
                      onChange={() => handleSelectItem(item)}
                    />
                  </td>
                  <td>
                    <p style={{ minWidth: "100px", textAlign: "left" }}>
                      {item.dishId.dishName}
                    </p>
                  </td>
                  <td>
                    <p style={{ minWidth: "100px", textAlign: "left" }}>
                      ₹ {item.resturantDishPrice}
                    </p>
                  </td>
                  <td>
                    <p style={{ minWidth: "100px", textAlign: "left" }}>
                      {item.dishId.dishCatagory}
                    </p>
                  </td>
                  <td>
                    {item.available ? (
                      <button
                        className="mark-unavailable"
                        onClick={() => handleMarkUnavaliable(item._id)}>
                        Mark Unavailable
                      </button>
                    ) : (
                      <button
                        className="mark-unavailable"
                        onClick={() => handleMarkUnavaliable(item._id)}>
                        Mark Available
                      </button>
                    )}
                    <button
                      className="delete"
                      onClick={() => {
                        setItemToDelete(item._id);
                        setShowDeletePopup(true);
                      }}>
                      Delete
                    </button>
                    <button
                      className="more-options"
                      onClick={(event) => togglePopup(index, event)}>
                      ⋮
                    </button>
                    {popupVisible === index && (
                      <div
                        className="popup"
                        style={{
                          width: "100px",
                          ...(isLastRow ? { top: "-40px" } : {}),
                        }}
                        ref={popupRef}>
                        <button onClick={() => handleEditClick(item)}>
                          Edit Details
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        )}
      </table>

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div className="delete-popup">
          <div className="delete-popup-content">
            <div className="warning-icon">
              <img src={warning} alt="warning" />
            </div>
            <p>Are you sure to delete this item ?</p>
            <div className="delete-button">
              <button onClick={handleDeleteItem} className="confirm-button">
                Yes
              </button>
              <button
                onClick={() => setShowDeletePopup(false)}
                className="cancel-button">
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {isEditModalOpen && (
        <EditModal
          isOpen={isEditModalOpen}
          onClose={handleOnCloseEditModal}
          dishDetails={selectedItem}
          onSave={handleSave}
          categoryList={categoryList}
        />
      )}
    </>
  );
};

export default MenuTable;


